import { Select, SelectOption } from '@percent/lemonade'
import { CountrySelectProps } from './CountrySelect.types'
import { useCountries } from '@percent/cause-dashboard/common/hooks'

export const CountrySelect = ({ value, ...props }: CountrySelectProps) => {
  const countries = useCountries()
  const countryCodes: SelectOption[] = countries.map(country => ({ value: country.code, label: country.name }))

  return (
    <Select
      options={countryCodes}
      defaultValue={countryCodes.find(country => country.value === value)}
      searchable
      {...props}
    />
  )
}
